import { DeleteDataCertification } from 'api/data-certifications-endpoint';
import ConfirmButton from 'components/ConfirmButton';
import { userHasRoles } from 'hooks/useRoleAuthorizationChecks';
import { ADMIN_DATA_CERTIFICATIONS } from 'navigator/links';
import { useNavigate, useParams } from 'react-router-dom';
import { useDataCertificationsContext } from 'stores/data-certifications-context';
import { DataCertification } from 'types/data-certification';
import { UserRole } from 'types/user';

interface DeleteDataCertificationButtonProps {
  dataCertification: DataCertification;
  className?: string;
  onDeleteFail: (message: string) => void;
}

function DeleteDataCertificationButton({ dataCertification, className, onDeleteFail }: DeleteDataCertificationButtonProps): JSX.Element {
  const dataCertificationsContext = useDataCertificationsContext();
  const navigate = useNavigate();
  const canDeleteDataCertification = userHasRoles([UserRole.VALIDATION_PORTAL_ADMIN]);

  if (!canDeleteDataCertification) {
    return <></>;
  }

  const handleClick = async () => {
    const response = await DeleteDataCertification(dataCertification.Id);
    if (response.success) {
      dataCertificationsContext.fetchData();
      navigate(ADMIN_DATA_CERTIFICATIONS);
    } else {
      onDeleteFail(response.message || '');
    }
  };

  return <ConfirmButton label='Delete' onClick={handleClick} className={className} />;
}

DeleteDataCertificationButton.defaultProps = {
  className: undefined,
};

export default DeleteDataCertificationButton;
